'use client'

import { useEffect } from 'react'
import { usePathname, useSearchParams, useRouter } from 'next/navigation'
import { useSafeRollbar } from '@/hooks/useSafeRollbar'

export default function NotFound() {
  const rollbar = useSafeRollbar()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const router = useRouter()

  useEffect(() => {
    const fullUrl = pathname + (searchParams.toString() ? `?${searchParams.toString()}` : '')

    rollbar.error('404 Page Not Found', {
      path: pathname,
      fullUrl,
      referrer: typeof window !== 'undefined' ? document.referrer : undefined,
      userAgent: typeof window !== 'undefined' ? navigator.userAgent : undefined,
    })

    router.push('/')
  }, [pathname, searchParams, rollbar, router])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-gray-600">Redirecting to homepage...</p>
    </div>
  )
}
